import BaseDevice from '../base.js'
import Switch from './switch.js'
import Point from './point.js'
export default class DeviceImage extends BaseDevice {

   static render = (device, scale = 1) => {
      const MODS = this.getMods(device.width)
      if (MODS < 4 || MODS > 6) return;
      const switchSVG = Switch.render(device.width, MODS);
      const pointSVG = Point.render(device.width);

      return this.getDevice(device, scale, pointSVG + switchSVG);
   }
}
